import { ServerEnv } from 'Configs/ServerEnv'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import storeAuth from 'GlobalStores/User/StoreAuth'
import HttpHelper from 'Services/HttpHelper'

export const PRODUCTS_V2_ERROR_DESCRIPTION = {
    key: 'description_handle_error_productsV2',
}

export const ExtractProductsV2ErrorDetails = error => {
    const message = error?.response?.data?.message
    if (Array.isArray(message)) return message.filter(m => typeof m === 'string' && m)
    if (typeof message === 'string' && message) return [message]
    return []
}

// ponytail: dev-only mock for USHOP-2865 — ?mockQuoteError=1|2|3|4 merges a quoteError fixture into the 200 response
const MOCK_QUOTE_ERRORS = {
    1: { errorCode: 'INVENTORY_UNAVAILABLE', retryable: false, customerMessageKey: 'quote_inventory_unavailable' },
    2: { errorCode: 'HYDRA_TIMEOUT', retryable: true, customerMessageKey: 'quote_temporarily_unavailable', hydraErrorCode: 'ETIMEDOUT' },
    3: { errorCode: 'REQUEST_INVALID', retryable: false, customerMessageKey: 'quote_request_invalid' },
    4: { errorCode: 'SOME_FUTURE_CODE', retryable: false, customerMessageKey: 'quote_temporarily_unavailable' }
}
export const GetFeelGreatProduct = userStatus => {
    let options = {}
    if (userStatus) {
        options.params = {
            baStatus: userStatus
        }
        if (['MAR', 'TUR', 'ZAF', 'SAU'].includes(StoreCountry.Country3())) {
            options.params.baId = storeAuth.GetId()
            options.params.ordercalC = 1
        }
        // console.log('options', options, storeAuth.GetId(), storeUser.GetBaStatus())
    } else if (StoreCountry.Country3() === 'JPN' && Boolean(userStatus) === false) {
        // JPN Default Case When
        options.params = {
            baStatus: 'C'
        }
    }

    if (ServerEnv.ENV === 'DEV') {
        if (options.params) {
            options.params.isQa = 1
        } else {
            options.params = {
                isQa: 1
            }
        }
    }

    // const qs = new URLSearchParams(window.location.search)
    // if (qs.get('env') === 'dev' || /localhost/.test(window.location.href) || /fg-dev/.test(window.location.href)) {
    //     severEnv = ServerEnv.MemberCalls2Dev()
    // }
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/products-v2/feelGreat/v3/publish/${StoreCountry.Country3()}`

    const request = HttpHelper.Get({ url, config: options })

    const mockKey = ServerEnv.IsDevDomain() ? new URLSearchParams(window.location.search).get('mockQuoteError') : null
    const fixture = MOCK_QUOTE_ERRORS[mockKey]
    if (fixture) {
        return request.then(res => ({ ...res, data: { ...res.data, isCallOrderCal: true, quoteError: fixture } }))
    }

    return request
}

export const GetProductCreditLight = userStatus => {
    const params = {}
    if (userStatus) {
        params.baStatus = userStatus
        params.baId = storeAuth.GetId()
    }
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/products-v2/feelGreat/v3/publish/productCredit/${StoreCountry.Country3()}`

    return HttpHelper.Get({ url, config: { params } })
}
